export const PURCHASE_CATEGORY = {
  PRE_ORDER: 'PreOrder',
  BACK_ORDER: 'BackOrder',
  NORMAL_ORDER: 'NormalOrder'
}
